import { render, staticRenderFns } from "./product-table.vue?vue&type=template&id=16e669bf&scoped=true"
import script from "./product-table.vue?vue&type=script&lang=ts"
export * from "./product-table.vue?vue&type=script&lang=ts"
import style0 from "./product-table.vue?vue&type=style&index=0&id=16e669bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e669bf",
  null
  
)

export default component.exports